import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { IFilterBarEvents, IFilterBarFields } from '../../components/FilterBar/types';
import { onAdd } from '../events/onAdd';
import { FilterBar } from '../../components/FilterBar/FilterBar';
import { getMyWorkPinnedFilterIdsCreateSelector } from './selector/getMyWorkPinnedFilterIds';
import {
    DEFAULT_FILTER_ID,
    FP_KEY_CARDS_FILTER_ASSIGNED_TO_ME,
    MY_WORK_FILTER_BOARD_ID
} from '../../../../../aside_panel/filterPanelBoard/constants';
import { onFilterClose } from '../../../../../main/topBar/hocs/MyWorkTopBarSearchHOC/events/onFilterClose';
import { getEnabledFilters } from '../../../../../../../store/model/middlewares/filters/selectors/getEnabledFilters';
import {
    getMyWorkFilterIsInitial
} from '../../../../../aside_panel/filterPanelBoard/store/selectors/getMyWorkFilterIsInitial';
import { getMyWorkGroupBy } from '../../../../../main/myWorkView/selectors/getMyWorkGroupBy';
import { getShowOnBarEnabledFilterCount } from './selector/getShowOnBarEnabledFilterCount';
import { onToggleCollapse } from '../events/onToggleCollapse';
import { onToggleAll } from '../events/onToggleAll';
import { getMyWorkFilterBarCollapsed } from '../../../../../main/myWorkView/selectors/getMyWorkFilterBarCollapsed';
import { getShowProFeaturesTrial } from '../../../../../../../store/model/authUser/selectors/getShowProFeaturesTrial';
import { onFilterPanelOpen } from './events/onFilterPanelOpen';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { getBoardTheme } from '../../../../../../../store/model/board/selectors/getBoardTheme';
import { MY_WORK_BOARD_ID } from '../../../../../main/myWorkView/constants';
import { onSort } from './events/onSort';
import { getAsidePanelWidth } from '../../../../../aside_panel/asidePanel/store/selectors/getAsidePanelWidth';

const mapStateToProps = () => {
    const getPinnedFilterIds = getMyWorkPinnedFilterIdsCreateSelector();

    return (
        state: IApplicationState
    ): IFilterBarFields => {
        const { allowSavedFilters } = getAuthUser(state);
        const filterIds = getPinnedFilterIds(state);
        const isSavedEnabledFilters = getEnabledFilters(state, MY_WORK_FILTER_BOARD_ID)
            .reduce((isSavedEnabledFilters, filter) => {
                const isAssignedToMe = filter.meta.isMyWorkReadonly && filter.name === FP_KEY_CARDS_FILTER_ASSIGNED_TO_ME;
                if (
                    filter.isEnabled && filter.id > DEFAULT_FILTER_ID &&
                    (allowSavedFilters || !isAssignedToMe)
                ) {
                    isSavedEnabledFilters = true;
                }
                return isSavedEnabledFilters;
            }, false);
        let isBoardTheme = false;
        const boardTheme = getBoardTheme(state, MY_WORK_BOARD_ID);
        if (boardTheme && boardTheme.id) isBoardTheme = true;

        return {
            allowSavedFilters,
            filterIds,
            groupBy: getMyWorkGroupBy(state),
            enabledFilterCount: getShowOnBarEnabledFilterCount(state),
            isAsidePanelOpened: !!getAsidePanelWidth(state),
            isFilter: !getMyWorkFilterIsInitial(state) || isSavedEnabledFilters,
            isCollapsed: getMyWorkFilterBarCollapsed(state),
            isProFeature: getShowProFeaturesTrial(state),
            isBoardTheme
        }
    };
}

const mapDispatchToProps = (
    dispatch: any
): IFilterBarEvents => ({
    onAdd: () => dispatch(onAdd()),
    onSort: (filterId, index) => dispatch(onSort(filterId, index)),
    onFilterOpen: () => dispatch(onFilterPanelOpen()),
    onFilterClose: () => dispatch(onFilterClose()),
    onToggleCollapse: () => dispatch(onToggleCollapse()),
    onToggleAll: () => dispatch(onToggleAll())
});

export const FilterBarHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(FilterBar);

FilterBarHOC.displayName = 'FilterBarHOC';
